import { PDFDocument, PageSizes, rgb } from 'pdf-lib'
import moment from 'moment'
import fontkit from '@pdf-lib/fontkit'

const SAMPLE_ATTENDEE = { name: "John", surname: "Doe", company: "Company Name", facilitySite: "Facility Name", idNumber: "1234567890123", employeeId: "EMP001", date: new Date(), user: { firstName: "Jane", lastName: "Smith" } };


export default {
    methods: {
        async generateCertificate(course, courseDetails, user, attendee) {
            const pdfDoc = await PDFDocument.create()
            pdfDoc.registerFontkit(fontkit)

            var page;

            if (courseDetails.certificateOrientation == "Landscape")
                page = pdfDoc.addPage([841.89, 595.28]);
            else
                page = pdfDoc.addPage(PageSizes.A4);

            // background first so it never covers text; Attendee* types would otherwise sort ahead of it
            var properties = [...courseDetails.certificateProperties].sort((a, b) => (b.type == "BackgroundImage") - (a.type == "BackgroundImage") || (a.type < b.type ? -1 : 1));
            for (var i = 0; i < properties.length; i++) {
                var property = properties[i];
                if (property.type == 'BackgroundImage' || (property.type == "Custom" && property.customType == "image")) {
                    var fileData = await this.loadFileAsync(property);
                    var image;

                    let fileName = property.imageFileName || property.fileName;
                    if (fileName.toUpperCase().endsWith(".PNG")) {
                        image = await pdfDoc.embedPng(fileData);
                    }
                    else {
                        image = await pdfDoc.embedJpg(fileData);
                    }

                    var width = property.type == "Custom" ? property.width : page.getWidth();
                    var height = property.type == "Custom" ? property.height : page.getHeight();
                    var xPos = property.type == "Custom" ? property.x : 0;
                    var yPos = property.type == "Custom" ? property.y : 0;

                    if (property.centerHorizontally) {
                        xPos = property.x + (page.getWidth() / 2) - (property.width / 2);
                    }
                    //validate y not greater than page height
                    page.drawImage(image, {
                        x: xPos,
                        y: yPos,
                        width: width,
                        height: height,
                    });
                }
                else {
                    var text = property.type;
                    if (property.type == "CourseName")
                        text = course.name;
                    else if (property.type == "StudentName") {
                        if (user)
                            text = user.firstName + " " + user.lastName;
                        else
                            text = "John Doe";
                    }
                    else if (property.type == "CompletionDate") {
                        if (courseDetails.userCompletedDate) {
                            text = moment(courseDetails.userCompletedDate).format("DD MMMM YYYY");
                        }
                        else {
                            text = moment().format("DD MMMM YYYY");
                        }
                    }
                    else if (property.type.startsWith("Attendee")) {
                        // a learner's own certificate has no attendee, so it prints nothing; the CMS preview (no user either) gets sample data
                        text = this.attendeeCertificateText(property.type, attendee || (user ? null : SAMPLE_ATTENDEE));
                    }
                    else if (property.type == "Custom") {
                        if (property.customType == "text") {
                            text = property.customText === "" || property.customText == null ? "Enter text" : property.customText;
                        }
                        else if (property.customType === "idNumber") {
                            text = "1234567890123";
                        }
                    }

                    //validate y not greater than page height
                    var definition = {
                        x: property.x,
                        y: property.y,
                        size: property.fontSize,
                        font: page.getFont()[0],
                        color: this.hexToRgb(property.colorHex)
                    }

                    if (property.file || property.fileName) {
                        var fontBytes = await this.loadFileAsync(property);
                        const customFont = await pdfDoc.embedFont(fontBytes);
                        definition.font = customFont;
                    }

                    if (property.centerHorizontally) {
                        definition.x = property.x + (page.getWidth() / 2) - (definition.font.widthOfTextAtSize(text, property.fontSize) / 2);
                    }
                    page.drawText(text, definition);
                }
            }

            const pdfBytes = await pdfDoc.save();

            return pdfBytes;
        },
        attendeeCertificateText(type, attendee) {
            if (!attendee)
                return "";

            switch (type) {
                // empty values fall back the same way the student fields do: name as-is, date to today, text to "Enter text"
                case "AttendeeName": return attendee.name + " " + attendee.surname;
                case "AttendeeCompany": return attendee.company || "Enter text";
                case "AttendeeFacilitySite": return attendee.facilitySite || "Enter text";
                // the facilitator is the user who captured the attendee
                case "AttendeeFacilitator": return attendee.user ? attendee.user.firstName + " " + attendee.user.lastName : "Enter text";
                // passport was merged into idNumber; AttendeePassport stays so templates saved with it still print
                case "AttendeeIdNumber":
                case "AttendeePassport": return attendee.idNumber || "Enter text";
                case "AttendeeEmployeeId": return attendee.employeeId || "Enter text";
                case "AttendeeDate": return moment(attendee.date || undefined).format("DD MMMM YYYY");
                default: return "";
            }
        },
        hexToRgb(hex) {
            // Remove the hash if it exists
            try {
                if (hex && hex.length) {
                    const cleanHex = hex.replace('#', '');
                    const bigint = parseInt(cleanHex, 16);
                    const r = (bigint >> 16) & 255;
                    const g = (bigint >> 8) & 255;
                    const b = bigint & 255;

                    return rgb(r / 255, g / 255, b / 255);
                }
            }
            catch (e) {
                console.error(e);
            }

            return rgb(0, 0, 0);
        },
        loadFileAsync(component) {
            // Always return a Promise
            const t = this;
            return new Promise((resolve, reject) => {

                if (component.file || component.imageFile) {
                    const reader = new FileReader();
                    // Wait till complete
                    reader.onload = function (event) {
                        // The file's text will be printed here
                        resolve(reader.result)
                    }
                    // Make sure to handle error states
                    reader.onerror = function (e) {
                        reject(e);
                    };
                    reader.readAsArrayBuffer(component.file ? component.file : component.imageFile);
                }
                else if (component.fileName || component.imageFileName) {

                    var url = t.$options.filters.s3url(component);
                    url += "?" + (new Date()).getTime();
                    var xhr = new XMLHttpRequest();
                    xhr.open('GET', url, true);
                    xhr.responseType = 'arraybuffer';

                    xhr.onload = async function (e) {
                        if (this.status == 200) {
                            // get binary data as a response
                            resolve(this.response);
                        }
                        else {
                            reject(e);
                        }
                    };

                    xhr.onerror = function (e) {
                        reject(e);
                    };

                    xhr.send();
                }
            });
        }
    }
}